export const experiences = [
  {
    role: "AI Tools Development Intern",
    company: "Vedabrata Rao Consultancy OPC Pvt. Ltd.",
    location: "Delhi, India",
    period: "Mar 2026 – May 2026",
    type: "internship",
    highlights: [
      "Built AI-powered consultation and workflow automation systems using LLM integrations and prompt engineering.",
      "Developed automated response pipelines that reduced manual handling and improved operational efficiency.",
      "Collaborated with stakeholders to design and deploy scalable AI-driven business solutions."
    ]
  },
  {
    role: "Team Lead (AI)",
    company: "SPIE - The International Society",
    location: "Delhi, India",
    period: "Oct 2025 – Mar 2026",
    type: "leadership",
    highlights: [
      "Led a 5-member engineering team to develop an AI-powered Practice Test Generator.",
      "Implemented automated question generation and answer evaluation workflows.",
      "Managed project planning, technical decisions, and delivery timelines."
    ]
  },
  {
    role: "Frontend Developer",
    company: "Assemble",
    location: "Remote",
    period: "Jun 2025 – Jul 2025",
    type: "internship",
    highlights: [
      "Developed reusable and responsive UI components.",
      "Improved accessibility and frontend consistency across applications.",
      "Standardized design patterns to accelerate feature delivery."
    ]
  },
  {
    role: "AI & IT Intern",
    company: "Ioncure Tech Pvt. Ltd.",
    location: "Delhi, India",
    period: "Feb 2025 – Apr 2025",
    type: "internship",
    highlights: [
      "Improved frontend architecture for a study-abroad platform.",
      "Enhanced responsive design and cross-device usability.",
      "Integrated AI-assisted automation workflows to streamline operations."
    ]
  },
  {
    role: "Tech Lead",
    company: "Book with UVA",
    location: "Delhi, India",
    period: "Aug 2024 – Feb 2025",
    type: "leadership",
    highlights: [
      "Led a 4-member full-stack development team.",
      "Improved user satisfaction by 20% through platform enhancements.",
      "Managed REST API integrations and development workflows."
    ]
  }
];


export const projects = [
{
title: "AI Consultation System",
desc: "Built an AI-powered consultancy workflow platform using Next.js, TypeScript, Node.js, and LLM integrations. Automated client interactions, response generation, and operational workflows through prompt engineering and intelligent automation pipelines.",
tags: [
{ name: "NextJS", color: "red-600" },
{ name: "TypeScript", color: "blue-600" },
{ name: "NodeJS", color: "green-600" },
{ name: "OpenAI", color: "yellow-600" }
],
img: "ai-consultation.jpg",
code: "#",
link: "#"
},

{
title: "AI Practice Test Generator",
desc: "Developed an AI-powered assessment platform capable of automated question generation, answer evaluation, difficulty balancing, and intelligent test workflow management using Python and prompt-based AI systems.",
tags: [
{ name: "ReactJS", color: "red-600" },
{ name: "Python", color: "blue-600" },
{ name: "NodeJS", color: "green-600" },
{ name: "AI", color: "yellow-600" }
],
img: "ai-practice-test.jpg",
code: "#",
link: "#"
},

{
title: "SafeTrails",
desc: "AI-powered tourist safety platform enabling live location tracking, emergency alerts, geo-fencing, and real-time monitoring. Built to improve traveler safety through intelligent tracking and rapid response workflows.",
tags: [
{ name: "NextJS", color: "red-600" },
{ name: "TailwindCSS", color: "yellow-600" },
{ name: "Git", color: "blue-600" }
],
img: "safetrails.jpg",
code: "https://github.com/gun03-hub/safe-trails-guardian",
link: "https://safetrails.netlify.app/"
},

{
title: "TheraLink",
desc: "Built a full-stack mental health platform featuring secure authentication, user dashboards, appointment workflows, and responsive interfaces designed to improve accessibility and user engagement.",
tags: [
{ name: "NextJS", color: "red-600" },
{ name: "NodeJS", color: "green-600" },
{ name: "MongoDB", color: "yellow-600" }
],
img: "theralink.png",
code: "#",
link: "#"
},

{
title: "Blockchain E-Voting System",
desc: "Developed a decentralized voting platform using blockchain technology, smart contracts, and cryptographic verification mechanisms to ensure secure and transparent elections.",
tags: [
{ name: "Solidity", color: "red-600" },
{ name: "JavaScript", color: "blue-600" },
{ name: "Blockchain", color: "yellow-600" }
],
img: "e-voting.jpg",
code: "#",
link: "#"
},

{
title: "My-Shop",
desc: "Built a full-stack e-commerce application with product catalog management, shopping cart functionality, search and filtering, authentication workflows, and scalable backend integration.",
tags: [
{ name: "NextJS", color: "red-600" },
{ name: "TypeScript", color: "blue-600" },
{ name: "MongoDB", color: "yellow-600" }
],
img: "My-shop.png",
code: "https://github.com/gun03-hub/My-shop",
link: "#"
}
];

